import React, {Fragment} from "react";
import {get, range} from "lodash";
import {useSelector} from "react-redux";
import {getQualifierGroups} from "apps/DRAW_PREDICTOR/modules/selectors";
import {ReactComponent as DisabledCardPlaceholder} from "apps/DRAW_PREDICTOR/assets/images/preDrawCardDisabled.svg";
import {ReactComponent as DoubleDisabledCardPlaceholder} from "apps/DRAW_PREDICTOR/assets/images/preDrawCardDisabledDouble.svg";
import {media} from "assets/css/media";
import {IQualifierGroup} from "apps/DRAW_PREDICTOR/modules/reducers";
import {Card, Cards, DoubleTeamCard, TeamCard} from "apps/DRAW_PREDICTOR/pages/preDraw/Card";
import {useMediaQuery} from "modules";

interface IGroupProps {
	group: IQualifierGroup;
}

const QualifierUEFA: React.FC<IGroupProps> = ({group}) => {
	const isDisabled = true;

	return (
		<Card index={group.id} isDisabled={isDisabled} group={group} isLast={false}>
			<Cards>
				<DoubleTeamCard>
					<DoubleDisabledCardPlaceholder />
				</DoubleTeamCard>
				<DoubleTeamCard>
					<DoubleDisabledCardPlaceholder />
				</DoubleTeamCard>
			</Cards>
		</Card>
	);
};

const QualifierCAF: React.FC<IGroupProps> = ({group}) => {
	const isDisabled = true;
	return (
		<Card index={group.id} isDisabled={isDisabled} group={group} isLast={false}>
			<Cards>
				<DoubleTeamCard>
					<DoubleDisabledCardPlaceholder />
				</DoubleTeamCard>
				<DoubleTeamCard>
					<DoubleDisabledCardPlaceholder />
				</DoubleTeamCard>
				<DoubleTeamCard>
					<DoubleDisabledCardPlaceholder />
				</DoubleTeamCard>
				<DoubleTeamCard>
					<DoubleDisabledCardPlaceholder />
				</DoubleTeamCard>
				<DoubleTeamCard>
					<DoubleDisabledCardPlaceholder />
				</DoubleTeamCard>
			</Cards>
		</Card>
	);
};
const TeamCardArrayPlaceholder = () => (
	<Cards className="single-team">
		{range(0, 12).map((key) => (
			<TeamCard key={key}>
				<DisabledCardPlaceholder />
			</TeamCard>
		))}
	</Cards>
);
const QualifierAFC: React.FC<IGroupProps> = ({group}) => {
	const isDisabled = true;
	return (
		<Card index={group.id} isDisabled={isDisabled} group={group} isLast={false}>
			<TeamCardArrayPlaceholder />
		</Card>
	);
};
const QualifierOFC: React.FC<IGroupProps> = ({group}) => {
	const isDisabled = true;
	return (
		<Card index={group.id} isDisabled={isDisabled} group={group} isLast={true}>
			<TeamCardArrayPlaceholder />
		</Card>
	);
};

export const PreRegisterCards: React.FC = () => {
	const isMobile = useMediaQuery(`(max-width: ${media.mobile})`);
	const groups = useSelector(getQualifierGroups);
	const firstGroup = get(groups, [0]);
	const secondGroup = get(groups, [1]);
	const thirdGroup = get(groups, [2]);
	const fourthGroup = get(groups, [3]);

	return (
		<Fragment>
			{isMobile ? (
				<QualifierUEFA group={firstGroup} />
			) : (
				<Fragment>
					<QualifierUEFA group={firstGroup} />
					<QualifierCAF group={secondGroup} />
					<QualifierAFC group={thirdGroup} />
					<QualifierOFC group={fourthGroup} />
				</Fragment>
			)}
		</Fragment>
	);
};
